import React, { useState, useEffect } from 'react';
import './shipmentStepProgress.css'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import CreateShipment from './CreateShipment.js';
import AddProductForm from './AddProduct.js';
import ConfirmShipment from './ConfirmShipment.js'
import {
  fetchShipmentById, createShipment, editShipment, deleteShipmentProduct, fetchOrdersToLink, addShipmentProduct,
  updateShipmentProduct, validateShipmentLotExistence
} from '../../../redux/shipmentSlice.js';
import { ProductColumnDefFn } from '../columns/ColumnDefShipment.js';
import MainTable from '../../../components/Table/PaginationTable.js';
import ShipmentStep from '../../../assets/images/ord-details.svg';
import ProductStep from '../../../assets/images/product.svg';
import Checkstep from '../../../assets/images/Check.svg';
import { ACTION } from '../../../helpers/commonName.js';
import ViewShipment from "./ViewShipment.js";
import AddLot from './AddLot.js';
import AddLotForProductWarningModal from '../../../components/Modals/AddLotForProductWarningModal.js';
import CreateShipmentModalComponent from '../../../components/Modals/CreateShipmentModalComponent.js'

export const icons = [
  { icon: ShipmentStep, text: 'Shipment Details' },
  { icon: ProductStep, text: 'Add Product' },
  { icon: Checkstep, text: 'Confirm Shipment' }
];

const ShipmentStepProgress = () => {

  const shipmentProducts = useSelector(state =>
    state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
      ? state.shipment.shipmentDetails.data.shipmentProducts
      : []);

  const [currentStep, setCurrentStep] = useState(1);
  const [actionType, setActionType] = useState(ACTION.ADD); // 'add', 'edit', 'view'
  const [productCount, setProductCount] = useState(0);
  const [selectedProductId, setSelectedProductId] = useState(null);
  // const [shipmentProducts, setShipmentProducts] = useState([]);
  const [isShipmentCreated, setIsShipmentCreated] = useState(false)
  const [isAddLot, setIsAddLot] = useState(false);
  const [isLinked, setIsLinked] = useState(false);
  const [shipmentId, setShipmentId] = useState(null);
  const [message, setMessage] = useState(null);
  const [isValidateLotModalOpen, setIsValidateLotModalOpen] = useState(false);
  const [isCreateShipmentSuccessModalOpen, setIsCreateShipmentSuccessModalOpen] = useState(false);
  // console.log("ISSHIPMENTCREATED",isShipmentCreated);
  // console.log("ACTIONTYPE",actionType);
  // console.log("PRODUCTCOUNT",productCount);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const shipmentDetails = useSelector((state) => state.shipment.shipmentDetails?.data || {});
  // console.log("finalllll shipmentDetails", shipmentDetails);

  useEffect(() => {
    //  console.log('$$$$$$$$$$$$', location)
    if (location?.state?.actionType === ACTION.EDIT) {
      const shipmentId = location?.state?.shipmentId;
      setActionType(location?.state?.actionType);
      setShipmentId(shipmentId)
      //  console.log('$$$$$$$$$$$$', actionType)
      if (shipmentId)
        dispatch(fetchShipmentById({ shipmentId, type: 'view' }))
      setProductCount(shipmentProducts?.length)
      // console.log("shipmentProducts shipmentProductsshipmentProducts",shipmentProducts)
    }
  }, [location]);

  const navigateCallback = (shipmentId, actionType) => {
    // Determine the path based on actionType
    const path = actionType === ACTION.EDIT ? `/edit/${shipmentId}` : `/details/${shipmentId}`;
    // setActionType(actionType);
    navigate(path);
  };

  const onValidateLotModalClose = () => {
    setIsValidateLotModalOpen(false);
  }

  const handleCreateShipmentModalClose = () => {
    setIsCreateShipmentSuccessModalOpen(false);
  }

  const handleCreate = () => {
    // console.log("INSIDE HANDLECREATE")
    let path = `/view-details-outbox/${shipmentId}`
    navigate(path);
  }

  const handleBack = () => {
    // console.log("Back button pressed!!")
    navigate('/outbox-shipment');
  }

  const handleStepChange = (stepNumber, action = 'add', productId = null) => {
    // console.log("productId",productId,stepNumber,action)
    if (stepNumber === 1) {
      setCurrentStep(stepNumber);
      isShipmentCreated ? setActionType('edit') : setActionType(action);
      setSelectedProductId(productId);
    } else if (stepNumber === 2 && isShipmentCreated === true) {
      setActionType(action);
      setCurrentStep(stepNumber);
      setSelectedProductId(productId);
    } else if (stepNumber === 3 && productCount >= 1) {
      setCurrentStep(stepNumber);
      setActionType(action);
      setSelectedProductId(productId);
    }
  };

  const handleShipmentProductEdit = (stepNumber, action, productId = null) => {
    // console.log("productId",productId,stepNumber,action,"currentStep in next isAddLot", isAddLot)
    if (stepNumber >= 1 && stepNumber <= 3) {
      setActionType(action);
      setSelectedProductId(productId); // For edit/view actions
      setCurrentStep(stepNumber); // uncommented to check edit product in confirm shipment screen
    }
  };

  const handleDeleteShipmentProduct = (productId) => {
    try{
    dispatch(deleteShipmentProduct({ shipmentId, productId }))
      .then(() => {
        dispatch(fetchShipmentById({ shipmentId, type: 'view' }));
      });
    }
    catch(err){
        console.log("Error occurred:",err)
      }
    setProductCount(productCount => productCount - 1);
  }

  const handleAddLot = (productId) => {
    setIsAddLot(true);
    setSelectedProductId(productId);
  }

  useEffect(() => {
    if (shipmentId) {
      dispatch(fetchShipmentById({ shipmentId, type: 'view' }));
    }
  }, [dispatch, currentStep]);

  const handleCreateShipmentSubmit = (data) => {
    // setIsShipmentCreated(true);
    if (isLinked || shipmentProducts?.length > 0) {
      setProductCount(shipmentProducts.length);
      // console.log("SHIPMENT ID IN CREATE SUBMIT",shipmentId);
    }
    //  console.log('Creating with:', data,"acrtty",actionType);
    if (actionType != ACTION.EDIT) {
      // Dispatch createShipment action
      dispatch(createShipment(data))
        .then((res) => {
          // console.log("shipmentId in handleCreateShipmentSubmit", res);
          if (res.type === 'shipment/createShipment/fulfilled') {
            setIsShipmentCreated(true);
            const shipmentId = res.payload;
            setShipmentId(shipmentId);
            // console.log("shipmentId",shipmentId);
            setCurrentStep(2); // Move to the next step after creating the shipment
          }
        }).catch((error) => {
          toast.error("Error occurred:", error);
        })
    } else {
      // Dispatch editShipment action

      dispatch(editShipment({
        shipmentId: shipmentId,
        shipmentData: data
      })).then(() => {
        // console.log("SHIPMENT ID",shipmentId)
        setActionType('add'); // Updating action Type to add to show add product page to user after editing the create shipment
        setCurrentStep(2)
        // dispatch(fetchShipmentById(shipmentId)).then(() => {
        // });
      })
      .catch((error) => {
        toast.error("Error occurred:", error);
      });
    }

  };

  const handleConfirmShipmentSubmit = async (data) => {
    // console.log("shipmentId shipmentProducts isLinked", isLinked, shipmentProducts?.length,shipmentProducts);
    // Dispatch editShipment action
    let navigateToReview = true;
    if ((!isLinked && productCount === 0) || (isLinked && shipmentProducts?.length === 0)) {
      setMessage("Please Add atleast one product to proceed");
      navigateToReview = false;
      setIsValidateLotModalOpen(true)
    } else {
      const response = await validateShipmentLotExistence(shipmentId, 'checkLotExists');
      // console.log("response",response);
      if (response === 0) {
        navigateToReview = false;
        setMessage("Please Add Lot to proceed");
        setIsValidateLotModalOpen(true)
      } else if (response === -1) {
        navigateToReview = false;
        setMessage("Are you sure you don't want to add lot for all products? Please delete those products for which you don't want to add lot.");
        setIsValidateLotModalOpen(true)
      }
    }
    dispatch(editShipment({
      shipmentId: shipmentId,
      shipmentData: data
    })).then(() => {
      if (navigateToReview) {
        setIsCreateShipmentSuccessModalOpen(true);
      }
    })
    .catch((error) => {
      toast.error("Error occurred:", error);
    });;
  };

  const handleAddOrEditProductSubmit = (productDetails) => {
    // console.log(`${actionType} product with:`, productDetails);
    // Dispatch addShipmentProduct or editProduct action based on actionType
    if (actionType === ACTION.ADD) {
      // console.log("shipmentId in handleAddOrEditProductSubmit",shipmentId);
      try{
      dispatch(addShipmentProduct({ shipmentId, productDetails }
      )).then((response) => {
        if(response.type === 'shipment/addShipmentProduct/fulfilled')
        {
        dispatch(fetchShipmentById({ shipmentId, type: 'view' }))
        setProductCount(productCount => productCount + 1);
        }
      });
    }
    catch(err){
      console.log("error");
    }
      // setShipmentProducts([ ...shipmentProducts, productDetails ])
      // console.log("shipmentProducts",shipmentProducts)
    } else if (actionType === ACTION.EDIT) {
      // console.log("edit in handleAddOrEditProductSubmit",productDetails);
      dispatch(updateShipmentProduct({
        shipmentId: shipmentId,
        shipmentProductId: selectedProductId,
        productData: productDetails
      }))
        .then(() => {
          dispatch(fetchShipmentById({ shipmentId, type: 'view' }));
        })
        .catch((error) => {
          toast.error("Error occurred:", error);
        });;
      setActionType('add'); //added to show user modified product 
    } else {
      // console.log("MOVED TO CONFIRM SCREEN")
      setCurrentStep(3); // Assuming you want to move to the next step
    }
    // console.log(" productcount",productCount);
  };

  const handlePrevious = () => {
    // console.log("currentStep in previous",currentStep)
    if (currentStep === 2) {
      setActionType('edit');
    }
    setCurrentStep(currentStep - 1); // Redirects to the Create Shipment Page 
  }

  const handleBackInAddLot = () => {
    // console.log("currentStep in previous",currentStep)
    setIsAddLot(false);
    setCurrentStep(currentStep); // Redirects to the Add Product Page 
  }

  const handleNext = async () => {
    // console.log("currentStep in next",currentStep)
    setCurrentStep(currentStep + 1); // To move to the next step 
  }

  const productColumn = ProductColumnDefFn(navigateCallback, handleShipmentProductEdit, handleDeleteShipmentProduct, handleAddLot);

  const updateProgressBar = () => ((currentStep - 1) / 2) * 100;

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <div className="step step-1 mt-2">
          {/* <h3>Shipment Details</h3> */}
          <CreateShipment
            onSubmit={handleCreateShipmentSubmit}
            handleStepChange={handleBack}
            currentStep={currentStep}
            actionType={actionType}
            isLinked={isLinked}
            setIsLinked={setIsLinked} />
        </div>
      case 2:
        // if (isShipmentCreated && actionType === ACTION.ADD || actionType === ACTION.EDIT) {
        // console.log("inside if case 2 Add Product actionType shipmentProducts", actionType, shipmentProducts)
        return <div className="step step-2 mt-2">
          {/* productId={selectedProductId} */}
          {/* <h3>Add Product</h3>  */}
          <AddProductForm
            isLinked={isLinked}
            currentStep={currentStep}
            shipmentId={shipmentId}
            selectedProductId={selectedProductId}
            actionType={actionType}
            productCount={productCount}
            onSubmit={handleAddOrEditProductSubmit}
            handlePrevious={handlePrevious}
            handleNext={handleNext} />
          {
            (isLinked == 1 || (productCount !== 0 && actionType != ACTION.EDIT))
              // || location?.state?.actionType === ACTION.EDIT 
              ?
              <>
                <div className='mt-5 ml-2'>
                  <h1 className="fprimary">Product Details</h1>
                </div>
                <MainTable
                  columns={productColumn}
                  data={shipmentProducts}
                  enablePagination={false}
                  className='mt-5'
                // initialPageSize={pageSize}
                // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
                // onPageSizeChange={handlePageSizeChange}
                // onPageIndexChange={handlePageIndexChange}
                />
              </> : null}
        </div>
      // }
      //  else {        
      //   // Assuming ViewProduct is a component you've created for viewing product details
      //   return <div className="step step-3"><ViewProduct productId={selectedProductId} /></div>
      // }
      case 3:
        // if(isShipmentCreated && productCount){
        return <>
          <div className="step step-1 mt-2">
            {/* <h3>Shipment Details</h3> */}
            <ConfirmShipment onSubmit={handleConfirmShipmentSubmit} handleStepChange={handleBack} handleBack={handlePrevious} productColumn={productColumn} />
          </div>
          {/* <div className='mt-5 ml-2'>
               <h1 className="fprimary">Product Details</h1>
           </div> */}
          {/* <MainTable
               columns={productColumn}
               data={shipmentProducts}
               enablePagination={false}
               className='mt-5'
           // initialPageSize={pageSize}
           // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
           // onPageSizeChange={handlePageSizeChange}
           // onPageIndexChange={handlePageIndexChange}
           /> */}
        </>

      // }
      default:
        return null
    }
  }

  return (
    <>
      {!isAddLot ?
        <div className="main-content">
          {/* Breadcrumb, progress bar, and other UI elements */}
          <nav aria-label="breadcrumb" class="bread-box">
            <div>
              <h1 className="fprimary">Create Shipment</h1>
              <h5 className="">Add shipment and products details to create a new shipment</h5>
            </div>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">Shipment</li>
              </ol>
            </div>
          </nav>
          <div className="bad-box">
            <span class="badge bg-danger red-bages">Please note: Kindly fill in all details in English characters only and within character limits as specified below.</span>
          </div>
          <div className="card mt-3 bg-stage bg-dot">
            <div className="card-body">
              <div className="step-progress">
                <div className="progress px-1" style={{ height: '3px' }}>
                  <div className="progress-bar" role="progressbar" style={{ width: `${updateProgressBar()}%` }} aria-valuenow={updateProgressBar()} aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div className="step-container d-flex justify-content-between mb-5">
                  {icons.map((step, index) => (
                    <div key={index} className={`step-circle ${currentStep === index + 1 ? 'active' : ''}`} onClick={() => handleStepChange(index + 1)}>
                      <img src={step.icon} alt={`Step ${index + 1}`} />
                      <span className="step-text">{step.text}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div id="multi-step-form">
                {renderStepContent()}
              </div>
            </div>
          </div>
          {/* Navigation buttons and other components */}
        </div>
        :
        <AddLot currentStep={currentStep} shipmentProductId={selectedProductId} shipmentId={shipmentId} actionType={actionType} productCount={productCount} onSubmit={handleAddOrEditProductSubmit} handlePrevious={handleBackInAddLot} handleNext={handleNext} />
      }
      {message &&
        <AddLotForProductWarningModal
          isOpen={isValidateLotModalOpen}
          onClose={onValidateLotModalClose}
          message={message}
        />}
      {isCreateShipmentSuccessModalOpen && <CreateShipmentModalComponent
        isOpen={isCreateShipmentSuccessModalOpen}
        handleClose={handleCreateShipmentModalClose}
        handleCreate={handleCreate}
      />}
    </>
  );
};

export default ShipmentStepProgress;
